import { render, staticRenderFns } from "./viewTable.vue?vue&type=template&id=c5b5c438&scoped=true"
import script from "./viewTable.vue?vue&type=script&lang=js"
export * from "./viewTable.vue?vue&type=script&lang=js"
import style0 from "./viewTable.vue?vue&type=style&index=0&id=c5b5c438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b5c438",
  null
  
)

export default component.exports